/**
 * المرحلة 1.35 — the ready WhatsApp link the desk taps: the recipient's
 * number and the message already written (domain/whatsapp.js). On a
 * computer it opens WhatsApp Web on that chat with the message in the box;
 * on a phone, the app. Every link opens in the same named tab, so the desk's
 * WhatsApp Web stays one tab however many patients it writes to.
 *
 * `url` is the server's wa.me link. With `preview` the message shows under
 * the link, as the patient will read it.
 */

import { Icon } from './index';
import { useI18n } from '../../i18n/I18nProvider';
import { displayNumber, onComputer, parseWhatsApp, whatsappHref } from '../../domain/whatsapp';

export function WhatsAppLink({ url, label, preview = false, className = '', testId = 'whatsapp-link', onOpen }) {
  const { t } = useI18n();
  const parsed = parseWhatsApp(url);
  if (!url || !parsed) return null;
  const computer = onComputer();
  const href = whatsappHref(url, { computer });
  const number = displayNumber(parsed.phone);
  return (
    <div className={`wa-ready ${className}`}>
      <a href={href} target="capsule-whatsapp" rel="noopener noreferrer" className="wa-ready__link" data-testid={testId} onClick={onOpen}>
        <span className="wa-ready__icon" aria-hidden="true">
          <Icon name="message-circle" size={18} />
        </span>
        <span className="wa-ready__text">
          <b>{label || t('whatsapp.send')}</b>
          <small>{number ? t(computer ? 'whatsapp.to' : 'whatsapp.toApp', { number }) : t('whatsapp.noNumber')}</small>
        </span>
        <Icon name="external-link" size={14} className="wa-ready__out" />
      </a>
      {preview && parsed.text && <p className="wa-ready__preview">{parsed.text}</p>}
    </div>
  );
}

export default WhatsAppLink;
